export const AcademyEmbeddedTypeDecorator = {
  url() {
    return `signup-hubspot/academy-embedded`;
  },

  query() {
    return {};
  }

};